import React from "react";
import { transformComma } from "../../../utils/validator/comma";

const RetroactiveDetails = ({ data }) => {
  if (!data) {
    return <p>데이터가 없습니다.</p>;
  }

  const backdatedList = data?.list || []; // 소급분 내역 리스트

  return (
    <>
      {/* 소급분 내역 테이블 */}
      <h4 className="si4n-subtitle">소급분 내역</h4>
      <table className="si4n-table">
        <thead>
          <tr>
            <th>순번</th>
            <th>성명</th>
            <th>주민등록번호</th>
            <th>기간(Start)</th>
            <th>기간(End)</th>
            <th>기준소득월액</th>
            <th>월수</th>
            <th>전월이전보험료</th>
          </tr>
        </thead>
        <tbody>
          {backdatedList.length > 0 ? (
            backdatedList.map((person, idx) => (
              <tr key={idx}>
                <td>{idx + 1}</td>
                <td>{person.bckDtlName}</td>
                <td>{person.bckDtlRrno?.replace(/.{6}$/, "******")}</td>
                <td>{person.bckDtlStartDt}</td>
                <td>{person.bckDtlEndDt}</td>
                <td>{transformComma(person.bckDtlStndIncmMthAmt)} 원</td>
                <td>{person.bckDtlMthCnt} 개월</td>
                <td>{transformComma(person.bckDtlBfrIns)} 원</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="8">소급분 내역이 없습니다.</td>
            </tr>
          )}
        </tbody>
      </table>
    </>
  );
};

export default RetroactiveDetails;